"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _logger = require("@insided/shared/services/logger");

var _preactCompat = require("preact-compat");

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("@insided/shared/uikit/Button"));

var _contentType = require("@insided/shared/utils/contentType");

var _topicService = require("../services/topicService");

var _inputUnit = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/input-unit"));

var _textArea = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/text-area"));

var _modal = _interopRequireWildcard(require("@insided/deprecated-preact-components/design-system-components/modal"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _translations = require("@insided/deprecated-libs/translationsUtils/translations");

var _common = require("@insided/shared/utils/common");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ReportContentModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ReportContentModal, _PureComponent);

  var _super = _createSuper(ReportContentModal);

  function ReportContentModal() {
    var _this;

    (0, _classCallCheck2.default)(this, ReportContentModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isLoading: false,
      reason: undefined,
      error: undefined
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onReport", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _this$props, contentType, topicId, replyId, userId, showReportContentModal, onShowAlert, reason;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, contentType = _this$props.contentType, topicId = _this$props.topicId, replyId = _this$props.replyId, userId = _this$props.userId, showReportContentModal = _this$props.showReportContentModal, onShowAlert = _this$props.onShowAlert;
              reason = _this.state.reason;

              if (!(!reason || reason === '')) {
                _context.next = 5;
                break;
              }

              _this.setState({
                error: (0, _preact.h)(_phrase.default, {
                  p: "topic_view.reported_content_modal.reason_not_provided.error"
                })
              });

              return _context.abrupt("return");

            case 5:
              _this.setState({
                isLoading: true
              });

              _context.prev = 6;

              if (!(replyId && userId)) {
                _context.next = 12;
                break;
              }

              _context.next = 10;
              return (0, _topicService.reportReply)(userId, reason, (0, _contentType.getConsistentContentType)(contentType), replyId);

            case 10:
              _context.next = 15;
              break;

            case 12:
              if (!(topicId && userId)) {
                _context.next = 15;
                break;
              }

              _context.next = 15;
              return (0, _topicService.reportTopic)(userId, reason, (0, _contentType.getConsistentContentType)(contentType), topicId);

            case 15:
              onShowAlert('success', (0, _preact.h)(_phrase.default, {
                p: "topic_view.reported_content.success"
              }));
              showReportContentModal(false);
              _context.next = 23;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](6);

              _logger.logger.error(_context.t0, {
                component: 'ReportContentModal',
                action: 'onReport'
              });

              onShowAlert('error', (0, _preact.h)(_phrase.default, {
                p: "topic_view.reported_content_modal.error"
              }));

            case 23:
              _this.setState({
                reason: undefined,
                isLoading: false,
                error: undefined
              });

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 19]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onContentChange", function (reason) {
      _this.setState({
        reason: reason,
        error: undefined
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCancel", function () {
      var showReportContentModal = _this.props.showReportContentModal;
      showReportContentModal(false);

      _this.setState({
        error: undefined
      });
    });
    return _this;
  }

  (0, _createClass2.default)(ReportContentModal, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          topicTitle = _this$props2.topicTitle,
          replyId = _this$props2.replyId;
      var _this$state = this.state,
          isLoading = _this$state.isLoading,
          error = _this$state.error,
          reason = _this$state.reason;

      var isThreadedRepliesEnabled = _common.common.isModuleActive('threadedRepliesDestination');

      var showTitle = !isThreadedRepliesEnabled || !replyId;
      return (0, _preact.h)(_modal.default, {
        onClose: this.onCancel
      }, (0, _preact.h)(_modal.ModalHeader, {
        title: (0, _preact.h)(_phrase.default, {
          p: "topic_view.reported_content_modal.report_content"
        })
      }), (0, _preact.h)(_modal.ModalBody, null, showTitle && (0, _preact.h)("div", {
        className: "form__row report-content--title"
      }, (0, _preact.h)("strong", null, replyId ? (0, _preact.h)(_phrase.default, {
        p: "topic_view.reported_content_modal.reply"
      }) : (0, _preact.h)(_phrase.default, {
        p: "topic_view.reported_content_modal.topic"
      })), (0, _preact.h)("p", null, topicTitle)), (0, _preact.h)("div", {
        className: "form__row report-content--note"
      }, (0, _preact.h)("p", null, (0, _preact.h)(_phrase.default, {
        p: "topic_view.reported_content_modal.note"
      }))), (0, _preact.h)("div", {
        className: "form__row report-content--reason"
      }, (0, _preact.h)(_inputUnit.default, {
        label: (0, _preact.h)(_phrase.default, {
          p: "topic_view.reported_content_modal.reason"
        }),
        error: error !== null && error !== void 0 ? error : undefined
      }, (0, _preact.h)(_textArea.default, {
        onContentChange: this.onContentChange,
        placeholder: (0, _translations.t)('Forum', 'topic_view.reported_content_modal.reason.placeholder'),
        size: "fullWidth",
        value: reason,
        verticalResize: true,
        maxLength: 250
      })))), (0, _preact.h)(_modal.ModalFooter, null, (0, _preact.h)("div", {
        className: (0, _classnames.default)('report-content-modal-buttons', {
          'modal-footer-buttons--threaded': isThreadedRepliesEnabled
        })
      }, (0, _preact.h)(_Button.default, {
        title: (0, _preact.h)(_phrase.default, {
          p: "topic_view.reported_content_modal.cancel"
        }),
        className: "btn btn-secondary",
        onClick: this.onCancel,
        size: "medium",
        "data-qa": "cancel-report",
        oldStyle: true
      }), (0, _preact.h)(_Button.default, {
        title: (0, _preact.h)(_phrase.default, {
          p: "topic_view.reported_content_option.report"
        }),
        className: "btn btn-primary",
        onClick: this.onReport,
        isLoading: isLoading,
        size: "medium",
        "data-qa": "report-post",
        oldStyle: true
      }))));
    }
  }]);
  return ReportContentModal;
}(_preactCompat.PureComponent);

var _default = ReportContentModal;
exports.default = _default;